<template>
  <div>
    <p class="text-sm mb-2 text-center text-staticsecondary-600 dark:text-staticdarkblue-200">
      Es necesario cambiar la contraseña al acceder por primera vez a la aplicación.
    </p>
    <el-form
      @submit.prevent.native="doLogin('firstLoginForm')"
      class="px-4 sm:px-0"
      :model="firstLoginForm"
      :rules="firstLoginFormRules"
      ref="firstLoginForm"
      novalidate
    >
      <div>
        <el-form-item  prop="oldPassword">
          <el-input
            ref="firstLoginPasswordInput"
            placeholder="Contraseña actual "
            type="password"
            class="mb-2 custom__icons static-css"
            show-password
            v-model="firstLoginForm.oldPassword"
            maxlength='50'
          >
            <i slot="prefix" class="el-input__icon">
              <BaseIcon size="sm" name="lock" />
            </i>
            <template v-if="firstLoginForm.oldPassword" slot="suffix">
              <base-clear-input-button
                aria-label="Limpiar campo de contraseña antigua"
                @clear="firstLoginForm.oldPassword = ''"
              />
            </template>
          </el-input>
        </el-form-item>
      </div>
      <base-password-form-item v-model="firstLoginForm.newPassword" name="newPassword" placeholder="Nueva contraseña " publicView/>
      <base-password-form-item v-model="firstLoginForm.repeatPassword" :password="firstLoginForm.newPassword" name="repeatPassword" placeholder="Confirmar contraseña " repeat publicView/>
      <div class="flex items-center justify-end ">
        <span class="block text-sm font-semibold text-staticprimary-800 dark:text-staticdarkblue-200 cursor-pointer hover:text-staticprimary"
          @click="cleanToggleForms()"
          >Volver a inicio de sesión</span>
      </div>
      <base-button
        class="w-full mt-4"
        mode="staticprimary"
        text="Acceder"
        type="submit"
        :loading = "loader"
      />
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'first-login-form',
  data: function () {
    return {
      loader: false,
      firstLoginForm: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
      },
      firstLoginFormRules: {
        oldPassword: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      }
    }
  },
  mounted: async function () {
    this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
      setTimeout(() => {
        this.fixAccesibilityElInputPassword(this.$refs.firstLoginPasswordInput, this.$i18n.t('aria.elementui.input.password'))
      }, 1000)
    })
  },
  methods: {
    cleanToggleForms () {
      this.$emit('cleanToggleForms')
    },
    doLogin: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loader = true
            const payload = {
              oldPassword: this.firstLoginForm.oldPassword,
              password: this.firstLoginForm.newPassword,
            }
            await this.$store.dispatch('auth/firstLoginPassword', payload)
            // await this.$store.dispatch('app/getAnnouncementsList')
          } catch (error) {
            if (error !== undefined && error.blnError) {
              if (error.stepCode === 2) {
                this.$emit('cleanToggleForms')
                this.$emit('activeLoginOTPConfig')
              } else if (error.stepCode === 3) {
                this.$emit('cleanToggleForms')
                this.$emit('activeLoginOTP')
              } else {
                this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
              }
            } else {
              this.doFeedback()
            }
          } finally {
            this.loader = false
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
  }
}
</script>

<style scoped>
.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
